export * from './user-accounts.service';
import { UserAccountsService } from './user-accounts.service';
export const APIS = [UserAccountsService];
